module.exports = __webpack_public_path__ + "img/office2.91bf3053.jpg";